















import { Component, Vue } from "vue-property-decorator";
import { ImagePreview } from "vant";
@Component({
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component
  }
})
export default class Zcap1 extends Vue {
  images: string[] = [];
  show: boolean = false;
  mounted(): void {
    if (ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.bottomBarConfig({
        isShowBottom: 0
      });
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "座次安排",
        isShowMoreBtn: "0"
      });
    } else {
      document.title = "座次安排";
    }

    this.images = ["https://h5cloud.cqliving.com/statics/temp/zwap1.png"];
  }

  imgPreview(): void {
    this.show = true;
  }
}
